<template>
  <div class="view-filter">
    <div class="control has-icons-left">
      <SpriteSymbol name="search" />
      <input
        v-model.lazy="term"
        class="input is-small"
        :placeholder="$texts('enterSearchTerm', 'Enter a search term')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getQueryParamString } from '~/helpers'

const route = useRoute()
const router = useRouter()
const { $texts } = useEasyTexts()

const term = computed({
  get: () => getQueryParamString(route.query, 'text'),
  set: (value: string) => {
    const query = { ...route.query }
    if (value) {
      query.text = value
    } else {
      delete query.text
    }
    router.push({
      name: route.name as string,
      query,
    })
  },
})
</script>

<style lang="postcss">
.view-filter {
  @apply w-full border-b border-solid border-border;
  padding-bottom: 1rem;
  & .icon {
    @apply flex items-center justify-center;
  }
}
</style>
